import { UncacheBoard, UncacheBoardVariables } from './__generated__/UncacheBoard'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UncacheBoard($input: UnCacheBoardInput!) {
    unCacheBoard(input: $input) {
      success
      id
    }
  }
`

export const useUncacheBoard = () => useMutation<UncacheBoard, UncacheBoardVariables>(MUTATION)
